import { useContext } from "react"
import Typography from "components/styled/Typography"
import { printNumber } from "helpers/formatter"
import { scrollToRef } from "helpers/scroll"
import TaxToggle from "components/styled/TaxToggle"
import styled from "styled-components"
import { color, mq } from "helpers/styled"
import { useLocale, useT } from "react-polyglot-hooks"
import { PrimaryButton } from "components/styled/Buttons/PrimaryButton"
import { sendEvent } from "scripts/GoogleAnalytics"
import { CarContext } from "../../CarContext"

const Title = styled(Typography)`
  margin-bottom: 5px;
`

const Italic = styled(Typography)`
  font-style: italic;
`

const From = styled(Typography)`
  > span {
    display: inline-block;
    margin-left: 5px;
  }
`

const Price = styled(Typography)`
  display: flex;
  align-items: baseline;

  span {
    margin-left: 5px;
  }
`

const OldPrice = styled.span`
  color: ${color("mediumVioletRed")};
  text-decoration: line-through;
`

const Toggle = styled.div`
  display: flex;
  justify-content: flex-end;
`

const PlanInfo = styled(Typography).attrs({
  variant: "small",
  color: "white",
  weight: "medium"
})`
  margin-top: 10px;

  > span {
    color: ${color("skyBlue")};
    font-style: italic;
  }
`

const Button = styled(PrimaryButton)`
  width: 100%;
  margin: 0;
  margin-top: 25px;
`

const FlexibleTitle = styled(Typography)`
    font-size: 10px;
    line-height: 24px;
    color: #bdbdbd;


    @media ${mq("md")} {
        margin: 0;
        font-size: 17px;
        line-height: 30px;
    }
`

function PlanHeader() {
  const t = useT()
  const locale = useLocale()
  const { car, formRef, selectedPlan, page, withoutTaxes, setWithoutTaxes } = useContext(CarContext)
  const { promotionOldPrice, kind, downPayment, sellingStatus} = car

  const handleClick = () => {
    sendEvent("Click CTA prices", { event_category: page, event_label: "Featured price" })
    scrollToRef(formRef)
  }

  return (
    <>
      {kind.includes("commercial") && (
        <Toggle>
          <TaxToggle withoutTaxes={withoutTaxes} setWithoutTaxes={setWithoutTaxes} page={page} />
        </Toggle>
      )}
      { sellingStatus === 'flexible' && <FlexibleTitle>Compra flexible</FlexibleTitle> }
      <Title color="white" variant="title2" el="h1" weight="bold">
        {`${car.brand} ${car.model}`}
        <Typography color="white" variant="title3" el="span">{`${car.version}`}</Typography>
      </Title>
      <From color="white" weight="medium">
        {t("common.from")}
        {promotionOldPrice && <OldPrice>{`${promotionOldPrice} €`}</OldPrice>}
      </From>
      <Price variant="title1" el="span" weight="bold" color="skyBlue">
        {withoutTaxes ? selectedPlan.priceWithoutTaxes : selectedPlan.price}
        <Typography variant="smallPrice" weight="bold" el="span" color="skyBlue">
          {t("common.currency")}
        </Typography>
        <Italic variant="smallPrice" el="span" color="white">
          {sellingStatus !== 'flexible' ? ` · ${t(withoutTaxes ? "common.without_tax" : "common.tax_included")}` : ''}
        </Italic>
      </Price>
      <PlanInfo>
        {locale === "it" && (
          <span>{downPayment ? t("common.down_payment", { downPayment }) : t("common.without_down_payment")} · </span>
        )}
        {t("common.plan", { km: printNumber(selectedPlan.kmYear), duration: selectedPlan.duration })}
      </PlanInfo>
      <div>
        <Button size="lg" onClick={handleClick} shadow>
          {t("car_data.plans.cta")}
        </Button>
      </div>
    </>
  )
}

export default PlanHeader
